module.exports = __webpack_public_path__ + "images/page_white_copy.png";